<script setup lang="ts" generic="OptionValueType">
import Icon from '@components/Icon.vue';
import { IconCaretUpDownBold } from '@icons';
import Typography from '@components/Typography.vue';
import { computed } from 'vue';

const { modelValue, options } = defineProps<{
  modelValue: OptionValueType,
  options: Map<OptionValueType, string>,
}>();

const emit = defineEmits<{(e: 'update:modelValue', value: OptionValueType): void }>();

const view = computed<OptionValueType>({
  get: () => modelValue,
  set: (value: OptionValueType) => emit('update:modelValue', value),
});

const label = computed<string>(() => options.get(modelValue) as string);
</script>

<template>
  <label
    data-cy-ref="view-dropdown"
    :class="[
      'fixed inset-x-2',
      'flex items-center justify-center gap-2',
      'box-border h-12 w-fit',
      'mx-auto px-3 py-4',
      'cursor-pointer rounded-lg border border-solid border-gray bg-white shadow-[0_2px_4px_0_rgba(0,0,0,0.10)]',
    ]"
  >
    <Icon :svg="IconCaretUpDownBold" width="20" height="20" fill="gray-darker" />

    <Typography
      class="pointer-events-none"
      variant="body-bold"
      color="black"
    >
      {{ label }}
    </Typography>

    <select
      v-model="view"
      data-cy-ref="view-dropdown-select"
      :class="[
        'absolute',
        'inset-0 appearance-none opacity-0',
        'cursor-pointer'
      ]"
    >
      <option
        v-for="[ optionValue, optionLabel ] in options"
        :key="optionValue as PropertyKey"
        :value="optionValue"
      >
        {{ optionLabel }}
      </option>
    </select>
  </label>
</template>
